import { render, staticRenderFns } from "./badge_pay.vue?vue&type=template&id=5695261f&scoped=true"
import script from "./badge_pay.vue?vue&type=script&lang=js"
export * from "./badge_pay.vue?vue&type=script&lang=js"
import style0 from "./badge_pay.vue?vue&type=style&index=0&id=5695261f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5695261f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5695261f')) {
      api.createRecord('5695261f', component.options)
    } else {
      api.reload('5695261f', component.options)
    }
    module.hot.accept("./badge_pay.vue?vue&type=template&id=5695261f&scoped=true", function () {
      api.rerender('5695261f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sites/badge_pay.vue"
export default component.exports